export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.8a1dab6b.ttf";